jQuery(document).ready(function onMobileSearchReady($) {
    "use strict";

    var $body = $('body');
    var $form = $('.mobile-search__search-field--primary');
    var $fake = $('.mobile-search__search-field--fake');
    var $button = $form.find('button');
    var $input = $form.find('input');
    var $searchResults = $('.mobile-search__search-results');
    var $loadingIndicator = $searchResults.find('.loading-indicator');
    var $noSearchResults = $searchResults.find('.mobile-search__search-no-results');

    var isLoadingIndicatorVisible = false;

    var templates = {
        result: '' +
            '<li class="search__result">' +
                '<a href="#">' +
                    '<div class="search__result__image">' +
                        '<img src="http://placehold.it/64x64" />' +
                    '</div>' +
                    '<div class="search__result__content">' +
                        '<h4></h4>' +
                        '<p></p>' +
                    '</div>' +
                '</a>'+
            '</li>'
    };

    var debounceTimeout = null;

    $form.on('submit', onFormSubmit);
    $input.on('input', onInputChange);
    $body.on('searchclose', onSearchClose);
    $body.on('searchopen', onSearchOpen);

    $fake.find('input').on('focus', onFakeFormActivity);
    $fake.find('button').on('click', onFakeFormActivity);

    function onFakeFormActivity(e) {
        e.preventDefault();
        $body.addClass('mobile-search--search-open');
        $body.removeClass('mobile-menu--open');
        $input.focus();
    }

    function onFormSubmit(e) {
        if(e != null)
            e.preventDefault();

        var needle = $input.val();
        if(needle.length < 2) {
            return;
        }

        $.ajax('/wp-json/tankbar-easy-search/v1/search/' + needle, {
            type: 'GET',
            accepts: 'application/json',
            success: onFormSubmitSuccess
        });
    }

    function onInputChange() {
        var needle = $input.val();
        if(needle.length < 2)
            return;

        $noSearchResults.hide();
        showLoadingIndicator();

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(onFormSubmit, 1000);
    }

    function onFormSubmitSuccess(response) {
        var $results = [];
        var $result
        var $title
        var $content
        var $image;

        for(var i = 0, l = response.length, result; i < l; ++i) {
            result = response[i];

            $result = $(templates.result);
            $image = $result.find('.search__result__image');

            $result.find('a').attr('href', result.url);
            $result.find('h4').text(result.title);
            $result.find('p').text(result.content);

            if(result.image == null) {
                $image.remove();
                $result.addClass('search__result--no-image');
            } else {
                $image.find('img').attr('src', result.image);
            }

            $result.addClass('search__result--' + result.type);

            $results.push($result);
        }

        hideLoadingIndicator();

        if($results.length === 0) {
            $searchResults.find('li').remove();
            $noSearchResults.show();
            return;
        }

        $searchResults.find('li').remove();
        $searchResults.append($results);
    }

    function onSearchClose() {
        $noSearchResults.hide();
        hideLoadingIndicator();
        $searchResults.empty();
        $searchResults.scrollTop(0);
        $input.val('');
    }

    function onSearchOpen() {
        $input.focus();
    }

    function showLoadingIndicator() {
        if(isLoadingIndicatorVisible)
            return;
        $searchResults.find('li').hide();
        $loadingIndicator.show();
        isLoadingIndicatorVisible = true;
    }

    function hideLoadingIndicator() {
        if(!isLoadingIndicatorVisible)
            return;
        $loadingIndicator.hide();
        $searchResults.find('li').show();
        isLoadingIndicatorVisible = false;
    }
});